import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import P from '../../../../../components/P';
import messages from '../../messages';
import Section from '../../../components/Section';
import ControlContainer from '../../../components/ControlContainer';
export default function SureGoAllBenefits(props) {
  const { TPAName, carrier } = props;
  return (
    <div>
      <Section>
        <ControlContainer>
          <P style={{ fontWeight: 'bold' }}>
            <FormattedMessage {...messages.authorization} />
          </P>
          <P>
            <FormattedMessage {...messages.iAUTHORIZEAny} values={{ TPAName: TPAName, CarrierName: carrier }} />
          </P>
          <P style={{ fontWeight: 'bold' }}>
            <FormattedMessage {...messages.patientAuthorization} />
          </P>
          <P>
            <FormattedMessage {...messages.patientAuthorizationBody} values={{ tpaName: TPAName }} />
          </P>
          <P style={{ fontWeight: 'bold' }}>
            <FormattedMessage {...messages.reimbursementAuthorizationAndMethod} />
          </P>
          <P>
            <FormattedMessage {...messages.reimbursementAuthorizationBody} values={{ tpaName: TPAName }} />
          </P>
        </ControlContainer>
      </Section>
    </div>
  );
}

SureGoAllBenefits.propTypes = {
  TPAName: PropTypes.any,
  carrier: PropTypes.any,
};



// WEBPACK FOOTER //
// ./app/containers/FastCover/StepDeclaration/components/SureGoAllBenefits/index.js